import { convertLineHeight, convertShadow, convertSpacing } from '@23degrees/shared-code/content/style';
import { FontFormat } from '@23degrees/shared-code/models';

export const convertFormatProperty = (property: keyof FontFormat, unit: string, fontFormat: FontFormat, sizeFactor: number = 1): object => {
  const fontStyle: any = {};
  switch (property) {
    case 'size':
      fontStyle['font-size'] = fontFormat.size! * sizeFactor + (unit || '');
      break;
    case 'lineheight':
      fontStyle['line-height'] = convertLineHeight(fontFormat.lineheight!);
      break;
    default:
      fontStyle[property] = fontFormat[property];
      break;
  }

  return fontStyle;
};

export const convertFontFormat = (fontFormat: FontFormat, prop?: keyof FontFormat, unit: string = '', sizeFactor: number = 1, background?: string) => {
  if (!fontFormat) return {};

  if (prop) {
    return convertFormatProperty(prop, unit, fontFormat, sizeFactor);
  }

  if (fontFormat.weight && typeof fontFormat.weight !== 'string') {
    console.log('!!! styleService font:', typeof fontFormat.weight, fontFormat);
  }

  const styleObj: any = {
    fontSize: `${fontFormat.size! * sizeFactor}px`,
    fontFamily: fontFormat.fontFamily,
    letterSpacing: `${fontFormat.letterSpacing || 0}px`,
    fontWeight: fontFormat.weight ? String(fontFormat.weight).replace('i', '') : 'normal',
    textAlign: fontFormat.position === 'auto' ? 'center' : fontFormat.position,
    color: fontFormat.color,
    lineHeight: convertLineHeight(fontFormat.lineheight),
    textShadow: convertShadow(fontFormat.shadow),
    margin: convertSpacing(fontFormat.margin!, sizeFactor),
    padding: convertSpacing(fontFormat.padding!, sizeFactor),
    fontStyle: fontFormat.fontStyle || 'normal',
  };

  if (background) {
    styleObj.background = background;
  }

  return styleObj;
};

const camelToKebab = (str: string) => str.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);

export const styleToCSS = (styleObj: object) => {
  const styles = Object.entries(styleObj);
  const cssStyles = styles.map(([key, value]) => `${camelToKebab(key)}:${value}`);
  return cssStyles.join(';');
};
